import { css } from "@/domains/emotion";
import { FC } from "react";

export const NotFoundPage: FC = () => {
  return <div className={containerStyles}>Not Found</div>;
};

const containerStyles = css({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100dvh",
  width: "100%",
  justifyContent: "center",
  minHeight: 200,
});
